import React from 'react';
import RatesEditor from './RatesEditor';

// Staff cost rates. These cost shifts for the margin reports only; pay comes from each person's
// pay group. Contractors are paid from the flat rate card on their profile, so any award rows
// they still carry are hidden (and counted) rather than shown as if they applied.
const CONFIG = {
  noun: 'staff member',
  endpoint: '/financials/staff-rates',
  idField: 'staff_id',
  nameField: 'staff_name',
  peopleUrl: '/staff?limit=500',
  peopleKey: 'staff',
  personLabel: 'Staff member',
  defaultLabel: 'Default (all staff)',
  allLabel: 'All staff',
  empty: { staff_id: '', shift_type: '', standard_rate: '', saturday_rate: '', sunday_rate: '', public_holiday_rate: '', pay_type: 'hourly', valid_from: '', valid_to: '' },
  intro: 'Cost rates used for margin reports, for employees only. Pay comes from pay groups, so changing a rate here does not change a payslip.',
  link: { to: '/settings/pay-groups', label: 'Open pay groups' },
  emptyHint: "Add a rate, or sync them from each staff member's pay group.",
  drawerHint: 'Used for margin reports only.',
  hideRow: (r) => r.employment_type === 'contractor',
  sync: {
    url: '/financials/sync-staff-rates',
    label: 'Sync from pay groups',
    title: 'Sync staff rates from pay groups?',
    confirm: "This creates or updates staff cost rates from each person's pay group (SCHADS) base rate and the weekend and holiday multipliers in Financial configuration. Rates you have entered by hand for the same person and shift type are overwritten.",
    processedKey: 'staff_processed',
  },
};

export default function StaffRates() {
  return <RatesEditor cfg={CONFIG} />;
}
